// extracted by mini-css-extract-plugin
module.exports = {"notice":"_1cCns","body":"_2dZhI","close":"_24ax8","bg":"_2igwS","content":"_1_g1F","text":"kV8Y8"};